import { FunctionComponent } from 'react';
import OtherTransactionInfo from './OtherTransactionInfo';

type FC = FunctionComponent;

const OtherTransactionContainer: FC = () => {
  return (
    <div>
      <OtherTransactionInfo />
    </div>
  );
};

export default OtherTransactionContainer;
